// extracted by mini-css-extract-plugin
export var blink = "_63-2";
export var cursor = "_63-1";
export var reactMarkdown = "_63-3";
export var streamingText = "_63-0";